import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { useQuery } from "@tanstack/react-query";
import { verifyToken } from "@/api/auth";

export default function useSignedFunction(fn: any) {
  const { data } = useQuery({
    queryKey: ["token-check"],
    queryFn: () => verifyToken(),
  });

  const router = useRouter();

  return useCallback(
    async (...args: unknown[]) => {
      if (!data?.valid) {
        return router.push("/login");
      }

      return fn(...args);
    },
    [fn, router, data],
  );
}
